/**
 * Mini App ↔ CRM Runtime feature flags (safe defaults: all off).
 * Vite: VITE_MINIAPP_CRM_* — never enable unfinished production flows silently.
 */

function envTrue(raw: unknown): boolean {
  if (typeof raw !== "string") return false;
  const n = raw.trim().toLowerCase();
  return n === "1" || n === "true" || n === "yes";
}

export const CRM_FLAG_NAMES = {
  integration: "VITE_MINIAPP_CRM_RUNTIME_ENABLED",
  liveCatalog: "VITE_MINIAPP_CRM_LIVE_CATALOG",
  liveCart: "VITE_MINIAPP_CRM_LIVE_CART",
  liveCheckout: "VITE_MINIAPP_CRM_LIVE_CHECKOUT",
  orderHistory: "VITE_MINIAPP_CRM_ORDER_HISTORY",
  recommendations: "VITE_MINIAPP_CRM_RECOMMENDATIONS",
  localDevAuth: "VITE_MINIAPP_CRM_DEV_AUTH_FALLBACK",
} as const;

export function isMiniAppCrmRuntimeEnabled(): boolean {
  return envTrue(import.meta.env.VITE_MINIAPP_CRM_RUNTIME_ENABLED);
}

export function isCrmLiveCatalogEnabled(): boolean {
  return isMiniAppCrmRuntimeEnabled() && envTrue(import.meta.env.VITE_MINIAPP_CRM_LIVE_CATALOG);
}

export function isCrmLiveCartEnabled(): boolean {
  return isMiniAppCrmRuntimeEnabled() && envTrue(import.meta.env.VITE_MINIAPP_CRM_LIVE_CART);
}

export function isCrmLiveCheckoutEnabled(): boolean {
  return isMiniAppCrmRuntimeEnabled() && envTrue(import.meta.env.VITE_MINIAPP_CRM_LIVE_CHECKOUT);
}

export function isCrmOrderHistoryEnabled(): boolean {
  return isMiniAppCrmRuntimeEnabled() && envTrue(import.meta.env.VITE_MINIAPP_CRM_ORDER_HISTORY);
}

export function isCrmRecommendationsEnabled(): boolean {
  return isMiniAppCrmRuntimeEnabled() && envTrue(import.meta.env.VITE_MINIAPP_CRM_RECOMMENDATIONS);
}

export function getCrmFeatureFlagSnapshot(): Record<string, boolean> {
  return {
    miniapp_crm_runtime_integration: isMiniAppCrmRuntimeEnabled(),
    live_catalog: isCrmLiveCatalogEnabled(),
    live_cart: isCrmLiveCartEnabled(),
    live_checkout: isCrmLiveCheckoutEnabled(),
    order_history: isCrmOrderHistoryEnabled(),
    recommendations: isCrmRecommendationsEnabled(),
    local_dev_auth_fallback: envTrue(import.meta.env.VITE_MINIAPP_CRM_DEV_AUTH_FALLBACK),
  };
}
